import { Flame } from "lucide-react";
import { MARQUEE } from "./data";

export const Marquee = () => {
  const items = [...MARQUEE, ...MARQUEE];
  return (
    <div data-testid="editorial-marquee" className="relative bg-[#0F1D2F] py-6 sm:py-8 overflow-hidden border-y border-[#CF5C0F]/30">
      <div className="marquee-track flex w-max">
        {[0, 1].map((k) => (
          <div key={k} className="flex shrink-0 items-center" aria-hidden={k === 1}>
            {items.map((t, i) => (
              <span key={`${k}-${i}`} className="flex items-center font-serif italic text-3xl sm:text-5xl text-[#FAF7F2] px-6 sm:px-10 whitespace-nowrap">
                {t}
                <Flame className="w-6 h-6 sm:w-8 sm:h-8 text-[#E69A28] ml-12 sm:ml-20" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
